const dictMixin = {
  methods: {
    async apiDictGetCountries ($axios = null) {
      $axios = $axios ?? this.$axios
      return await $axios.get('/dict/countries').then((res) => {
        return res?.data
      }, (err) => {
        return err?.response?.data
      })
    },
    async apiDictGetPopularTags ($axios = null) {
      $axios = $axios ?? this.$axios
      return await $axios.get('/dict/tags-popular').then((res) => {
        return res?.data
      }, (err) => {
        return err?.response?.data
      })
    }
  }
}

export default dictMixin
